var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../ts/components/LazyLoader';
import { Navigator } from '../../../ts/components/Navigator';
import { ProjectManager } from '../../components/Project';
export class Inventory extends Component {
    constructor() {
        super('Inventory', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('body').on('mouseover', '.inventory-row', (event, button) => {
                const image_src = LazyLoader.get_src(button.data('previewImage'));
                if (Inventory.lastSrc !== image_src) {
                    $('.inventory-preview .slide-image').css('background-image', `url('${image_src}')`);
                    Inventory.lastSrc = image_src;
                }
            }).on('mouseout', '.inventory-row', (event, button) => {
                $('.inventory-preview .slide-image').css('background-image', `url('')`);
                Inventory.lastSrc = '';
            });
            $('body').on('click', '.inventory-row', (event, link) => {
                if ($('body').hasClass('home')) {
                    event.preventDefault();
                    const projectId = parseInt(link.data('projectId'));
                    const projectIndex = $(`.project[id="project-${projectId}"]`).index();
                    const slideIndex = parseInt(link.data('slideIndex'));
                    Navigator.navigate(link.attr('href'), 'scroll', projectIndex, slideIndex, false);
                    $('main').get(0).scrollTo({ top: projectIndex * $(window).height(), behavior: 'instant' });
                    console.log(projectIndex, ProjectManager.projects);
                    if (slideIndex === 0)
                        ProjectManager.projects[projectId].jumpTo(slideIndex, 'instant');
                }
            });
            this.success();
        });
    }
}
Inventory.lastSrc = '';
